$(function () {
  let hashchanged = false
  $(window).one('hashchange', () => {
    hashchanged = true
  })

  $('[data-back-link]').on('click', function (event) {
    if (!document.referrer) return
    if (hashchanged) return

    let value = $(this).data('back-link')
    let getComparable =
      {
        path: url => url.pathname,
        href: url => url.href,
      }[value] ?? (url => url.origin)

    if (
      getComparable(new URL(this.href)) ===
      getComparable(new URL(document.referrer))
    ) {
      event.preventDefault()
      history.back()
    }
  })
})
